import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import EditorialIntro from '../components/EditorialIntro';
import FeaturedExhibitions from '../components/FeaturedExhibitions';
import VisualBreak from '../components/VisualBreak';
import SelectedWorks from '../components/SelectedWorks';
import Journal from '../components/Journal';
import Footer from '../components/Footer';

const HomePage = () => {
    return (
        <div className="bg-bone text-charcoal" data-testid="dimirxson-home">
            <Header />
            <main>
                <Hero />
                <EditorialIntro />
                <FeaturedExhibitions />
                <VisualBreak />
                <SelectedWorks />
                <Journal />
            </main>
            <Footer />
        </div>
    );
};

export default HomePage;
